import { render } from "./Contact.vue?vue&type=template&id=204c7990"
import script from "./Contact.vue?vue&type=script&lang=js"
export * from "./Contact.vue?vue&type=script&lang=js"
script.render = render

export default script